import React, { useEffect, useState } from "react";
import { AgGridReact } from "ag-grid-react";
import moment from "moment";
import {useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  getProformaTreeListAction, 
  getProformaDateAction,
  getProformaRebalanceAction,
  getProformaBackfillAction,
} from "../../../../actions/proformaAction";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import { AllocationTab } from "./AllocationTab";
import { ProformasTreeGrid } from "./ProformasTreeGrid";
import { AllocationDetails } from "./AllocationDetails";
import { Modal } from 'react-bootstrap';
import{ deleteProformaByID  } from "../../../../../config/apiConfig";
import { sbaAxios } from "../../../../utils/sbaAxios";
import { SBNotify } from "../../../../utils/sbNotify";
import { ToastContainer } from "react-toastify";

export const ProformasListsGrid = ({ ProformaList ,render,setRender }) => {
  
  const dispatch = useDispatch();
  const locationData = useLocation();
  const Gstate =
    useSelector((state) => {
      return state;
    }) || {};
    
  const isEditable =Gstate.authorizationData.isEditable;
  const gridData = ProformaList?.ProformaListData || [];
  const [profromaID,setProfromaID]=useState();
  

  const [proformaGridRowData, setProformaGridRowData] = useState("");
  const [toDeleteProforma,setToDeleteProforma]=useState();
  const [showModal,setShowModal]=useState(false);
  const [allocationParams, setAllocationParams]=useState({
    "InitialValue": null,
    "StartDate": null,
    "EndDate": null,
    "AllocationMode": null,
    "RebalanceMethod": null,
    "RebalanceStart": null,
    "Backfill": null,
    "AutomatedReturns": null,
    "Fees": null,
    "FeesPercentage": null
  });
  const [activeTab,setActiveTab]=useState("Allocation");
  
  useEffect(()=>{
    dispatch(getProformaDateAction("date"));
    dispatch(getProformaRebalanceAction("rbm"));
    dispatch(getProformaBackfillAction("bf")); 
  },[]);

  const gridValueFormatter = (params) => {
    return moment(params.value).format("MM/DD/YYYY");
  };
  
  const ActionsRenderer = (props) => {
    const proforma=props.data;
    const handleDeleteClick = (e) => {
      if(isEditable !== false){
        setShowModal(true);
        setToDeleteProforma(proforma);
      }
    };

    return (
      <div className="actions-cell">       
        <i
          className="fa fa-trash"
          style={{ color: isEditable === false ? "#808080" : "#DF001B", margin: "0 8px", cursor: "pointer" }}
          onClick={(e)=>handleDeleteClick(e)}
        ></i>
      </div>
    );
  };

  const columnDefs = [
    {
      field: "HPName",
      headerName: "Proforma Name",
      filter: 'agTextColumnFilter',
      onCellClicked: (params) => {
        const rowData = params.data;
        setProformaGridRowData(rowData);
        setProfromaID(params.data.HPId);
        setActiveTab('Allocation');
        dispatch(getProformaTreeListAction(params.data.HPId));
      },    
    },
    {
      field: "FromDate",
      headerName: "Start Date",
      valueFormatter: gridValueFormatter,
    },
    {
      field: "ToDate",
      headerName: "End Date",
      valueFormatter: gridValueFormatter,
    },
    {
      field: "Action",
      headerName: "Action",
      maxWidth: 150,
      cellRenderer: ActionsRenderer,
      filter: false,
    },
  ];

  const defaultColDef = {
    sortable: true,
    filter: true,
    floatingFilter: true,
    flex: 1,
    resizable:true
  };
  const deleteSelectedProforma=()=>{
    const proformaID=toDeleteProforma.HPId;
    sbaAxios({url:`${deleteProformaByID}/${proformaID}`,method:"post"}).then(
      resposnse=>{
        setShowModal(false);
        SBNotify({Msg:"Selected Proforma Deleted Successfully" ,type:"success"});
        setTimeout(() => {
          setProformaGridRowData("");
          setRender(!render);
        },1000 );
      }
    ).catch((e)=>{
      setShowModal(false);
      console.log(e,'error deleting the proforma');
    })
  };
  const previouslyActiveTab = locationData.state === null ? "Allocation" : locationData.state.ActiveTab;

  return (
    <>
      <div className="col-lg-12">
        <div className="col-lg-12">
          <div
            className="ag-theme-alpine"
            style={{ width: "100%", height: "350px" }}
          >
            <AgGridReact
              columnDefs={columnDefs}
              rowData={gridData}
              defaultColDef={defaultColDef}
              pagination={true}
              paginationPageSize={20}
              rowSelection={"single"}
            ></AgGridReact>
          </div>
        </div>
        <br></br> 
        {proformaGridRowData!=="" &&  <>
        <div className="col-lg-12 mb-4">
          <h4 className="fw-bold m-0">{proformaGridRowData.HPName}</h4>
        </div>
        <div className="col-lg-12">
          {proformaGridRowData && (
            <div className="asset-detail-screen">
            <Tabs
              activeKey={activeTab}
              id="uncontrolled-tab-example"
              className="ms-3"
              onSelect={(k)=>{setActiveTab(k)}}
            >
              <Tab eventKey="Allocation" title="Allocation" >
                
               {activeTab==="Allocation" && <>
                <div className="p-3 bg-white life-science rounded mb-4">
                
                   <AllocationTab ActiveButton={"Allocation"} allocationParams={allocationParams} setAllocationParams={setAllocationParams} ProfromaID={profromaID}/>
                 
                  
                 
                </div>
                <div>
                  <ProformasTreeGrid ProformaDetails={proformaGridRowData} ActiveButton={"Allocation"} allocationParams={allocationParams} setProfromaID={setProfromaID} ProfromaID={profromaID}/>
                </div>
                </>
                }
              </Tab>
              <Tab eventKey="AllocationDetails" title="Allocation Details" >
                <div className="p-3 bg-white life-science rounded">
                  {
                    activeTab==="AllocationDetails" && <>
                  <AllocationDetails ProfromaID={profromaID}/>
                    </>
                  }
                </div>
              </Tab>
            </Tabs>
            </div>
          )}
        </div></>}
      </div>
      <Modal show={showModal}>
        <Modal.Header
          closeButton
          onClick={() => {
            setShowModal(false);
          }}
        >
          <Modal.Title>
            Do you want to Delete the Selected Proforma?
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>
            The Selected Proforma List will be Deleted Permanently. Are you
            sure?
          </p>
        </Modal.Body>
        <Modal.Footer>
          <button
            className="s-sm-btn mx-1"
            onClick={() => {
              setShowModal(false);
            }}
          >
            Cancel
          </button>
          <button
            className="p-sm-btn mx-1"
            onClick={() => {
              deleteSelectedProforma();
            }}
          >
            Yes
          </button>
        </Modal.Footer>
      </Modal>
      <ToastContainer />
    </>
  );
};
